export class IError {
  constructor(
    public readonly statusCode: number,
    public readonly message: string,
    public readonly error: string,
  ) {}
}
